import {
  BarChart3,
  BookOpen,
  Box,
  Briefcase,
  Building,
  Building2,
  Calculator,
  Calendar,
  Clock,
  CreditCard,
  DollarSign,
  FileCheck,
  FileSearch,
  FileText,
  FolderOpen,
  GitBranch,
  Home,
  Kanban,
  Layers,
  LayoutDashboard,
  List,
  type LucideIcon,
  Package,
  Percent,
  Plane,
  Plus,
  Receipt,
  Route,
  Scale,
  Settings,
  Shield,
  Ship,
  Sliders,
  Target,
  TrendingUp,
  Truck,
  UserCheck,
  UserCog,
  Users,
  Wallet,
  Warehouse,
} from 'lucide-react'

const ICONS: Record<string, LucideIcon> = {
  BarChart3,
  BookOpen,
  Box,
  Briefcase,
  Building,
  Building2,
  Calculator,
  Calendar,
  Clock,
  CreditCard,
  DollarSign,
  FileCheck,
  FileSearch,
  FileText,
  FolderOpen,
  GitBranch,
  Home,
  Kanban,
  Layers,
  LayoutDashboard,
  List,
  Package,
  Percent,
  Plane,
  Plus,
  Receipt,
  Route,
  Scale,
  Settings,
  Shield,
  Ship,
  Sliders,
  Target,
  Truck,
  TrendingUp,
  UserCheck,
  UserCog,
  Users,
  Wallet,
  Warehouse,
}

export function getLucideIcon(name: string | undefined | null): LucideIcon {
  if (!name) return Box
  return ICONS[name] ?? Box
}
